import validate from "/Users/jdo/org/brx/deck/2025/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.3.2_eslint@9.29.0_jiti@2.4.2__iore_yilis3q7jcecmris4ivtqcy3o4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/jdo/org/brx/deck/2025/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.3.2_eslint@9.29.0_jiti@2.4.2__iore_yilis3q7jcecmris4ivtqcy3o4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authenticated: () => import("/Users/jdo/org/brx/deck/2025/middleware/authenticated.ts")
}